

import waxjs from "../lib/wallets/waxjs.js"
import AnchorLinkBrowserTransport from "../lib/wallets/anchor-link-browser-transport"
import AnchorLink from "../lib/wallets/anchor-link"
import {deserialize,  RpcApi} from 'atomicassets'
import base58_to_binary from '../lib/crypto/base58_to_binary.ts';


let TemplateData=[null];

let wax= null;
let explore = null;
let link = null;
let isAutoLoginAvailable = false;
const tires = [{ id: 201, force: 6000, friction: 200, stiffness: 20, damping: 0.2, compression: 0.6, tire: "tire", name: "free tire" , width: 0.2, radius: 0.3}];
const motors = [{ id: 101, maxEngineForce: 300, maxBreakingForce: 30 , name: "free motor", "motor": "engine", "nitro" : 1.0, "a" : -0.0000043, "b" : 0.033, "c" : 125}];
export const cars = [{ id: "1", type :-1, isDemo:false, DMG:null, mdata:'', claim:false, template_mint :"-1", class:'', isfree: true, name: "free car", maxdmg : 0, chassis: 'car2', massVehicle: 350, steeringClamp: 0.4, steeringIncrement: .04, suspensionRestLength: 0.60, motorid: 101, tireid: 201, motor: null, suspension: null , radar: null, battery: null, weapon: null   }];

export const demo_cars_wax = { testnet: [100000000082127], 
                                mainnet : [100000020302794]};


    function hexToBytes(hex) {
        for (var bytes = [], c = 0; c < hex.length; c += 2)
            bytes.push(parseInt(hex.substr(c, 2), 16));
        return bytes;
    }

    export async function get_config_wax(mainContract) {

        var config_r = null;

        const creq = {
            json: true,                             // Get the response as json
            code: mainContract,       // Contract that we target
            scope: mainContract,      // Account that owns the data
            table: 'config',                    // Table name
            limit: 1,                              // Maximum number of rows that we want to get
            reverse: false,                         // Optional: Get reversed data
            show_payer: false                       // Optional: Show ram payer
        };

        try {
            config_r = await wax.rpc.get_table_rows(creq);
        }
        catch (e) {
            console.error('get_config : unable to fetch config table ' + e.message);
            return {nitro_price : 0, steel_per_up: 0, per: 0, repair_time: 0};
        }

        if (config_r.rows.length <= 0) {
            console.error('no config table ');
            return null;
        }

        const arrn = config_r.rows[0].nitro_price.split(' ');
        const arrsup = config_r.rows[0].steel_per_up.split(' ');
        return {nitro_price : parseFloat(arrn[0]), steel_per_up: parseFloat(arrsup[0]), per: parseFloat(config_r.rows[0].per), repair_time: config_r.rows[0].repair_time}


    }


    export function resetwax(){
        wax = null;
        explore = null;
    }

    
    export function initwax( ep, contractAA = '') {

        if(wax === null){
            wax = new waxjs.WaxJS({ rpcEndpoint: ep, freeBandwidth: false });
            wax.isAutoLoginAvailable().then((av) => { isAutoLoginAvailable  = av})
        }
            

        if((contractAA.length>0)&&(explore === null)){

            try{
                explore = new RpcApi(ep, contractAA);
            }
            catch(e){
                
            }
            
        }
            
    }

     export function initanchor( ep, chainId) {

        if(link !== null)
            return;

       try {
            const transport = new AnchorLinkBrowserTransport();
            link = new AnchorLink({ transport, chains: [{ chainId: chainId, nodeUrl: ep }] });
        }
        catch (e) {
            console.log('unable to initialize anchor wallet ' + e.message);
        }
    }

    export async function getDemoCarsSM(assetLists, mainConstract, contractSA, collectionName, testnet){

        const cars = testnet ? demo_cars_wax.testnet : demo_cars_wax.mainnet;

        for(let id of cars){
            const car = await getCarSA(collectionName, id, mainConstract, contractSA, collectionName);
            if(!car)
                continue;

            car.isDemo = true;
            car.type = -2;
            assetLists['cars'].push(car);
        }
    }

    export async function getCarSA(account, id, mainContract, contractSA, collectionName) {
        let result;

        var req = {
            json: true,                             // Get the response as json
            code: contractSA,       // Contract that we target
            scope: account,                  // Account that owns the data
            table: 'sassets',                        // Table name
            limit: 1,                              // Maximum number of rows that we want to get
            reverse: false,                         // Optional: Get reversed data
            show_payer: false,                       // Optional: Show ram payer
            lower_bound: id
        };

        try {
            result = await wax.rpc.get_table_rows(req);
        }
        catch (e) {
            //alert('error getCarSA: ' + e.message);
            console.warn('error getCarSA: ' + e.message);
            return null;
        }

        if (result.rows.length <= 0) {
            //alert('getCarSA: not found ' + id);
            console.warn('wrong car not found ');
            console.warn(result);
            return null;
        }

        const iid = parseInt(result.rows[0].id);
        if (iid !== id) {
            //alert('getCarSA: wrong id ' + id + '!=' + iid);
            console.warn('wrong car id '+iid+' '+id);
            console.warn(result);
            return null;
        }

        if ((result.rows[0].author !==collectionName) || (result.rows[0].category !== 'cars')) {
            //alert('getCarSA: wrong category ');
            console.warn('wrong collection or category '+result.rows[0].author+' '+collectionName+' '+result.rows[0].category);
            console.warn(result);
            return null;
        }

        const idata = JSON.parse(result.rows[0].idata);
        const mdata = result.rows[0].mdata;
        const asset = { id: iid.toString(), isfree:false, template_mint: "-1", isDemo:false,  claim : false,  type: 0, 
            maxdmg: parseInt(idata.maxdmg), 
            name: idata.name, 
            chassis: idata.chassis, 
            class: idata.class ? idata.class: 'C', 
            massVehicle: parseFloat(idata.massVehicle), 
            steeringClamp: parseFloat(idata.steeringClamp), 
            steeringIncrement: parseFloat(idata.steeringIncrement), 
            suspensionRestLength: idata.suspensionLength ? parseFloat(idata.suspensionLength): 0.4, 
            mdata: mdata, DMG: null,  suspension : null,motor : null,weapon: null,radar: null,battery: null};

        
        let sus = null;
        let motor = null;
        let weapon = null;
        let radar = null;
        let battery = null;


        try {
            const jmdata = JSON.parse(mdata);

            if (jmdata.suspension)
                sus = { name: jmdata.suspension.name, tire: jmdata.suspension.tire, class: jmdata.suspension.class, 
                        force: parseFloat(jmdata.suspension.force), 
                        compression: parseFloat(jmdata.suspension.compression), 
                        stiffness: parseFloat(jmdata.suspension.stiffness), 
                        damping: parseFloat(jmdata.suspension.relaxation ? jmdata.suspension.relaxation : jmdata.suspension.damping), 
                        friction: parseFloat(jmdata.suspension.friction), 
                        width: jmdata.suspension.width ? parseFloat(jmdata.suspension.width) : 0.2, 
                        radius: jmdata.suspension.radius ? parseFloat(jmdata.suspension.radius)  : 0.5
                    };

            if (jmdata.motor)
                motor = {   name: jmdata.motor.name, motor: jmdata.motor.motor, class: jmdata.motor.class ? jmdata.motor.class: 'C', 
                            maxEngineForce: parseFloat(jmdata.motor.power ? jmdata.motor.power : jmdata.motor.maxEngineForce), 
                            maxBreakingForce: parseFloat(jmdata.motor.braking ? jmdata.motor.braking :  jmdata.motor.maxBreakingForce), 
                            nitro: jmdata.motor.nitro ? parseFloat(jmdata.motor.nitro) : 1.0, 
                            a: jmdata.motor.a ? parseFloat(jmdata.motor.a) : -0.0000048,
                            b: jmdata.motor.b ? parseFloat(jmdata.motor.b) : 0.04, 
                            c: jmdata.motor.c ? parseFloat(jmdata.motor.c) : 125};


            if (jmdata.weapon)
                weapon = {  name: jmdata.weapon.name, model: jmdata.weapon.model, class: jmdata.weapon.class, 
                            projSpeed: parseFloat(jmdata.weapon.speed), 
                            projMass: parseFloat(jmdata.weapon.mass) , 
                            projDelay : parseFloat(jmdata.weapon.rate) , 
                            projSize : parseFloat(jmdata.weapon.size) * 10, 
                            power : parseFloat(jmdata.weapon.power),
                            durability : parseFloat(jmdata.weapon.durability), 
                            dmg :  parseFloat(jmdata.weapon.dmg), 
                            blastForce : jmdata.weapon.blastForce !== undefined ? jmdata.weapon.blastForce : 4000, 
                            blastRadius : jmdata.weapon.blastRadius !== undefined ? jmdata.weapon.blastRadius : 5
                         };

            if (jmdata.radar)
                radar = {  name: jmdata.radar.name, model: jmdata.radar.model, class: jmdata.radar.class, 
                            angle: parseFloat(jmdata.radar.angle), range: parseFloat(jmdata.radar.range) , power : parseFloat(jmdata.radar.power)
                            };
            /*
            else
                radar = {  name: "basic radar", model: "radar1", class: "C", 
                            angle: 60, range: 40 , power : 3
                        };
            */

            if (jmdata.battery)
                battery = {   name: jmdata.battery.name, model: jmdata.battery.model, class: jmdata.battery.class, 
                                charge: parseFloat(jmdata.battery.charge), power : parseFloat(jmdata.battery.power)
                            }; 
            /*                            
                else                       
                    battery =  { name: "normal battery", model: "battery1", class: "C", 
                                charge: 1,  power : 500
                            };                   
            */
        }
        catch (e) {
            //alert('getCarSA: error parsing mdata '+e.message);
            console.warn('getCarSA: error parsing mdata '+e.message);
            return null;
        }


        asset.suspension = sus;
        asset.motor = motor;
        asset.weapon = weapon;
        asset.radar = radar;
        asset.battery = battery;

        await getDamageWax(asset, mainContract, 0);

        return asset;

    }

    export async function getCarAA(account, id, mainContract, contractAA, collectionName) {

        let result;

        var req = {
            json: true,                             // Get the response as json
            code:contractAA,       // Contract that we target
            scope: account,                  // Account that owns the data
            table: 'assets',                        // Table name
            limit: 1,                              // Maximum number of rows that we want to get
            reverse: false,                         // Optional: Get reversed data
            show_payer: false,                       // Optional: Show ram payer
            lower_bound: id
        };

        try {
            result = await wax.rpc.get_table_rows(req);
        }
        catch (e) {
           alert('getCarAA: ' + e.message);
            return null;
        }

        if (result.rows.length <= 0) {
            alert('getCarAA: not found ' + id);
            console.log(result);
            return null;
        }

        const iid = parseInt(result.rows[0].asset_id);
        if (iid !== id) {
            alert('getCarAA: wrong id ' + id);
            console.log(result);
            return null;
        }

        if ((result.rows[0].collection_name !== collectionName) || (result.rows[0].schema_name !== 'cars')) {
            alert('getCarAA: wrong asset type ');
            console.log(result);
            return null;
        }

        const idata = await getSchema(result.rows[0], contractAA, collectionName);

        const asset = { id: iid.toString(), type: 1, claim : false, template_mint:'-1', isfree:false, isDemo : false, maxdmg: idata.maxdmg, name: idata.name,class: idata.class,chassis: idata.chassis, massVehicle: idata.massVehicle, steeringClamp: idata.steeringClamp, steeringIncrement: idata.steeringIncrement, suspensionRestLength: idata.suspensionLength, DMG: null , suspension: null, motor : null, weapon : null, battery : null, radar : null, mdata : null};

        var jmdata;

        try {
            jmdata = await getMSchema(result.rows[0], contractAA, collectionName);
        }
        catch (e) {
            jmdata = { suspension: null, motor: null };
            console.log("getCarAA jmdata error " + e.message)
        }

        let suspension;
        let motor;

        if(idata.suspension){
            const str = base58_to_binary(idata.suspension);
            const SchemaT = await explore.getSchema(collectionName, "tires");
            const formT = await SchemaT.format();

            //formT.attributes.splice(2,1);
            asset.suspension = await deserialize(str, formT);
            asset.suspension.damping = asset.suspension.relaxation;
        }else if (jmdata.suspension){
            asset.suspension = jmdata.suspension;
            asset.suspension.damping = jmdata.suspension.relaxation;
        }
        else
            asset.suspension = null;

        if(idata.motor){
            const str = base58_to_binary(idata.motor);
            const SchemaT = await explore.getSchema(collectionName, "motors");
            const formT = await SchemaT.format();
            asset.motor = await deserialize(str, formT);
        }else if (jmdata.motor)
            asset.motor = jmdata.motor;
        else
            asset.motor = null;

        if(idata.battery){
            const str = base58_to_binary(idata.battery);
            const SchemaB = await explore.getSchema(collectionName, "batteries");
            const formB = await SchemaB.format();
            asset.battery = await deserialize(str, formB);
        }else if (jmdata.battery)
            asset.battery = jmdata.battery;
        else
            asset.battery = null;
        
        if(idata.radar){
            const str = base58_to_binary(idata.radar);
            const SchemaR = await explore.getSchema(collectionName, "radars");
            const formR = await SchemaR.format();
            asset.radar = await deserialize(str, formR);
        }else if (jmdata.radar)
            asset.radar = jmdata.radar;
        else
            asset.radar = null;
        
        if(idata.weapon){
            const str = base58_to_binary(idata.weapon);
            const SchemaW = await explore.getSchema(collectionName, "weapons");
            const formW = await SchemaW.format();
            asset.weapon = await deserialize(str, formW);
        }else if (jmdata.weapon)
            asset.weapon = jmdata.weapon;
        else
            asset.weapon = null;            

        await getDamageWax(asset, mainContract, 0);

        return asset;
    }
export async function getBalanceWax(myAccount, mainContract){
        
    const req1 = {
        json: true,                             // Get the response as json
        code: "eosio.token",                   // Contract that we target
        scope: myAccount,                // Account that owns the data
        table: 'accounts',                      // Table name
        limit: 1000                             // Maximum number of rows that we want to get
    };

    let result = null;

    try{
        result = await wax.rpc.get_table_rows(req1);
    }catch(e){
        console.log('getBalanceWax error '+e.message);
        return {stl : '-', main : '-'};
    }
    
    let balance = '0.00';

    for (let n = 0; n < result.rows.length; n++) {
        var arr = result.rows[n].balance.split(' ');
        if (arr[1] === 'WAX') {
            balance = parseFloat(arr[0]).toFixed(3);
        }
    }
    const req2 = {
        json: true,                            // Get the response as json
        code: mainContract,   // Contract that we target
        scope: myAccount,                // Account that owns the data
        table: 'accounts',                    // Table name
        limit: 1                              // Maximum number of rows that we want to get
    };

    const STEELres = await wax.rpc.get_table_rows(req2);
    let steelBalance = '0.00';

    if (STEELres.rows.length > 0) {
        var arr = STEELres.rows[0].balance.split(' ');
        steelBalance = parseFloat(arr[0]).toFixed(3);
    }

    return {stl : steelBalance, main : balance};
    }   

    
    
    export async function doRecipe(blockchaininfos, id){
        
        var dreq = {
            json: true,                             // Get the response as json
            code: blockchaininfos.mainContract,       // Contract that we target
            scope: blockchaininfos.mainContract,      // Account that owns the data
            table: 'recipe',                    // Table name
            lower_bound : id,
            limit: 1,                              // Maximum number of rows that we want to get
            reverse: false,                         // Optional: Get reversed data
            show_payer: false                       // Optional: Show ram payer
        };

        let recipes;
        
        try{
            recipes = await wax.rpc.get_table_rows(dreq);
        }catch(e){
            alert('getRecipes : could not read recipe tabe !');
            return;
        }

        if(recipes.rows.length < 1 ){
            alert('getRecipes : could not read recipe !');
            return;
        }

        if(recipes.rows[0].id != id){
            alert('getRecipes : could not find recipe !');
            return;
        }
        const memo = 'r:'+id;

        const q = parseFloat(recipes.rows[0].steel).toFixed(4) + ' STEEL';
        
        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "transfer", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { from: blockchaininfos.myAccount, to: blockchaininfos.mainContract, quantity: q, memo: memo } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
      }

    export async function getUserInfosWax(myAccount, mainContract) {

        if (myAccount === null) {
            return null;
        }

        //const uid = this.serName(this.myAccount);

        var req = {
            json: true,                             // Get the response as json
            code: mainContract,       // Contract that we target
            scope: mainContract,      // Account that owns the data
            table: 'userdatas',                        // Table name
            lower_bound: myAccount,
            limit: 1,                              // Maximum number of rows that we want to get
        };

        let nitro;
        
        try{
            nitro = await wax.rpc.get_table_rows(req);
        }catch(e){
            console.log('getNitrosWax : could not read user data tabe !')
            return null;
        }
    
        if ((nitro.rows.length === 0) || (nitro.rows[0].owner !== myAccount)) {
            return null;
        }

        return {nitros : nitro.rows[0].nitros ? nitro.rows[0].nitros : 0, techBalance : nitro.rows[0].techs ? (nitro.rows[0].techs / 100) : 0, bluePrints : nitro.rows[0].blueprints, quests : nitro.rows[0].quests};
    }

    export async function getPrizesWax(myAccount, mainContract){
    
        var dreq = {
            json: true,                             // Get the response as json
            code: mainContract,       // Contract that we target
            scope: mainContract,      // Account that owns the data
            table: 'userdatas',                    // Table name
                lower_bound: myAccount,
                limit: 1,                              // Maximum number of rows that we want to get
                reverse: false,                         // Optional: Get reversed data
                show_payer: false                       // Optional: Show ram payer
        };

        let infos;
        
        try{
            infos = await wax?.rpc.get_table_rows(dreq);
        }catch(e){
            console.log('getPrizesWax : could not read user data tabe !')
            return 0;
        }

        if ((infos.rows.length > 0) && (infos.rows[0].owner === myAccount)) 
            return infos.rows[0].prizes;
        else
            return 0;
    
    }

    export async function  getDamagesWax(assetLists, mainContract){
        let damages = null;
        let next_key= null;

        do {
            let dreq = {
                json: true,                             // Get the response as json
                code: mainContract,       // Contract that we target
                scope: mainContract,      // Account that owns the data
                table: 'cardammage',                    // Table name
                reverse: false,                         // Optional: Get reversed data
                show_payer: false                       // Optional: Show ram payer
            };

            if (next_key !== null) {
                dreq.lower_bound = next_key;
            }

                damages = await wax.rpc.get_table_rows(dreq);

                for (let n = 0; n < assetLists.cars.length; n++) {
                    for (let d = 0; d < damages.rows.length; d++) {
                        if (damages.rows[d].id == assetLists.cars[n].id) {
                            assetLists.cars[n].DMG = { time: damages.rows[d].time, damage: damages.rows[d].damage }
                        }
                    }
                }

                if (damages.more === true)
                    next_key = parseInt(damages.next_key);
                else
                    next_key = null;

        } while (damages.more)
    }

    export async function getDamageWax(icar, mainContract, update) {

        if (!icar.DMG) {

            console.log('getDamageWax');

            var dreq = {
                json: true,                             // Get the response as json
                code: mainContract,       // Contract that we target
                scope: mainContract,      // Account that owns the data
                table: 'cardammage',                    // Table name
                lower_bound: icar.id,
                limit: 1,                              // Maximum number of rows that we want to get
                reverse: false,                         // Optional: Get reversed data
                show_payer: false                       // Optional: Show ram payer
            };

            try{
                const damages = await wax.rpc.get_table_rows(dreq);

                console.log(damages);

                if ((damages.rows.length > 0) && (parseInt(damages.rows[0].id) === parseInt(icar.id))) {
                    icar.DMG = damages.rows[0];
                }
                
            }catch(e){

                console.log('getDamageWax '+e.message);

                icar.DMG =null;

            }
            
        }

        /*
        if (update > 0) {
            dmgTimer = setTimeout(function () { self.getDamage(icar, update); }, 1000);
        }
        */
    }



    export async function getAssetsSA(assetLists, myAccount , categories, contract, collectionName) {
        let next_key = null;
        let result, oresult, aresult;
        let ids = [];

        //const assetLists = {cars : new Array<any>,tires:new Array<any>,motors:new Array<any>,batteries:new Array<any>, radars : new Array<any>, weapons : new Array<any>}

        var oreq = {
            json: true,                             // Get the response as json
            code: contract,
            table: `offers`,
            scope: contract,
            key_type: `name`,
            index_position: 3,
            lower_bound: myAccount,
            higher_bound: myAccount,
            limit: -1,
            reverse: false,                         // Optional: Get reversed data
            show_payer: false                       // Optional: Show ram payer
        };

        try {
            oresult = await wax.rpc.get_table_rows(oreq);
        }
        catch (e) {
            alert('error getAssetsSA offers' + e.message);
            return assetLists;
        }

        var oids = [];
        for (let n = 0; n < oresult.rows.length; n++) {
            if (oresult.rows[n].owner !==collectionName)
                continue;

            oids.push(oresult.rows[n].assetid);
        }

        // no upper_bound provided, need to check if owner is actually the account we queried
        if (oids.length > 0) {
            do {

                var areq = {
                    json: true,                              // Get the response as json
                    code: contract,         // Contract that we target
                    scope: collectionName,  // Account that owns the data
                    table: 'sassets',                        // Table name
                    limit: -1,                               // Maximum number of rows that we want to get
                    reverse: false,                          // Optional: Get reversed data
                    show_payer: false,                        // Optional: Show ram payer
                    lower_bound : 0
                };

                if (next_key !== null) {
                    areq.lower_bound = next_key;
                }

                try {
                    aresult = await wax.rpc.get_table_rows(areq);
                }
                catch (e) {
                    alert('error getAssetsSA ' + e.message);
                    return assetLists;
                }

                for (let n = 0; n < aresult.rows.length; n++) {

                    if (oids.indexOf(aresult.rows[n].id) < 0)
                        continue;

                    if (aresult.rows[n].author !== collectionName)
                        continue;

                    if (categories.indexOf(aresult.rows[n].category) < 0)
                        continue;

                    let aid = parseInt(aresult.rows[n].id);
                    if (ids.indexOf(aid) >= 0)
                        continue;

                    const idata = JSON.parse(aresult.rows[n].idata);
                    const mdata = aresult.rows[n].mdata;

                    let asset;
                    let sus = null;
                    let motor = null;
                    let weapon = null;
                    let radar = null;
                    let battery = null;

                    if (aresult.rows[n].category == 'cars') {
                        var jmdata;
                        try {
                            jmdata = JSON.parse(mdata);

                            if (jmdata.suspension)
                                sus = { name: jmdata.suspension.name, tire: jmdata.suspension.tire, class: jmdata.suspension.class, force: parseFloat(jmdata.suspension.force), compression: parseFloat(jmdata.suspension.compression), stiffness: parseFloat(jmdata.suspension.stiffness), damping: parseFloat(jmdata.suspension.relaxation ? jmdata.suspension.relaxation : jmdata.suspension.damping), friction: parseFloat(jmdata.suspension.friction), width: parseFloat(jmdata.suspension.width), radius: parseFloat(jmdata.suspension.radius) };

                            if (jmdata.motor)
                                motor = { name: jmdata.motor.name, motor: jmdata.motor.motor, class: jmdata.motor.class, maxEngineForce: parseFloat(jmdata.motor.power ? jmdata.motor.power : jmdata.motor.maxEngineForce), maxBreakingForce: parseFloat(jmdata.motor.braking ? jmdata.motor.braking : jmdata.motor.maxBreakingForce) , nitro : jmdata.motor.nitro , a : jmdata.motor.a, b : jmdata.motor.b, c : jmdata.motor.c };

                            if (jmdata.weapon)
                                weapon = {  name: jmdata.weapon.name, model: jmdata.weapon.model, class: jmdata.weapon.class, 
                                            projSpeed: parseFloat(jmdata.weapon.speed), projMass: parseFloat(jmdata.weapon.mass) , projDelay : parseFloat(jmdata.weapon.rate) , projSize : parseFloat(jmdata.weapon.size), power : parseFloat(jmdata.weapon.power),durability : parseFloat(jmdata.weapon.durability),dmg : parseFloat(jmdata.weapon.dmg) 
                                         };

                            if (jmdata.radar)
                                radar = {  name: jmdata.radar.name, model: jmdata.radar.model, class: jmdata.radar.class, 
                                            angle: parseFloat(jmdata.radar.angle), range: parseFloat(jmdata.radar.range) , power : parseFloat(jmdata.radar.power)
                                         };

                            if (jmdata.battery)
                                battery = {     name: jmdata.battery.name, model: jmdata.battery.model, class: jmdata.battery.class, 
                                                charge: parseFloat(jmdata.battery.charge), power : parseFloat(jmdata.battery.power)
                                          };
            

                        }
                        catch (e) {
                            console.log('unable to parse mdata '+e.message+' '+mdata);
                            jmdata = { suspension: null, motor: null, weapon: null, battery: null, radar: null };
                        }

                        asset = { id: aresult.rows[n].id.toString(), DMG : null, templateç_mint: -1, type: 0, claim: true, name: idata.name, chassis: idata.chassis, class: idata.class, massVehicle: parseFloat(idata.massVehicle), steeringClamp: parseFloat(idata.steeringClamp), steeringIncrement: parseFloat(idata.steeringIncrement), maxdmg: parseInt(idata.maxdmg), suspensionRestLength: parseInt(idata.suspensionLength), suspension: sus, motor: motor, weapon: weapon, radar: radar, battery: battery, mdata: mdata };

                        assetLists.cars.push(asset);
                    }
                    else if (aresult.rows[n].category == 'tires'){
                        asset = { id: aresult.rows[n].id.toString(), templateç_mint: -1, type: 0, claim: true, name: idata.name, tire: idata.tire, class: idata.class, force: parseFloat(idata.force), compression: parseFloat(idata.compression), stiffness: parseFloat(idata.stiffness), damping: parseFloat(idata.relaxation ? idata.relaxation : idata.damping), friction: parseFloat(idata.friction), width: parseFloat(idata.width), radius: parseFloat(idata.radius), mdata: mdata };
                        assetLists.tires.push(asset);
                    }else if (aresult.rows[n].category == 'motors'){
                        asset = { id: aresult.rows[n].id.toString(), templateç_mint: -1, type: 0, claim: true, name: idata.name, motor: idata.motor, class: idata.class, maxEngineForce: parseFloat(idata.power ? idata.power : idata.maxEngineForce ), maxBreakingForce: parseFloat(idata.braking), nitro : idata.nitro , a : idata.a, b : idata.b, c : idata.c, mdata: mdata };
                        assetLists.motors.push(asset);
                    }else if (aresult.rows[n].category == 'batteries'){
                        asset = { id: aresult.rows[n].id.toString(), templateç_mint: -1, type: 0, claim: true, name: idata.name, model: idata.model, class: idata.class, model: idata.model, charge: parseFloat(idata.charge), power : parseFloat(idata.power), mdata: mdata };
                        assetLists.batteries.push(asset);
                    }else if (aresult.rows[n].category == 'radars'){
                        asset = { id: aresult.rows[n].id.toString(), templateç_mint: -1, type: 0, claim: true, name: idata.name, model: idata.model, class: idata.class, angle: parseFloat(idata.angle), range: parseFloat(idata.range) , power : parseFloat(idata.power), mdata: mdata };
                        assetLists.radars.push(asset);
                    }else if (aresult.rows[n].category == 'weapons'){
                        asset = { id: aresult.rows[n].id.toString(), templateç_mint: -1, type: 0, claim: true, name: idata.name, model: idata.model, class: idata.class, projSpeed: parseFloat(idata.speed), projMass: parseFloat(idata.mass) , projDelay : parseFloat(idata.rate) , projSize : parseFloat(idata.size), power : parseFloat(idata.power), durability : parseFloat(idata.durability), dmg : parseFloat(idata.dmg) , mdata: mdata };
                        assetLists.weapons.push(asset);
                    }


                    ids.push(aid);
                }

                if (aresult.more === true)
                    next_key = parseInt(aresult.next_key);
                else
                    next_key = null;

            } while (aresult.more)
        }

        do {

            var req = {
                json: true,                             // Get the response as json
                code: contract,       // Contract that we target
                scope: myAccount,                  // Account that owns the data
                table: 'sassets',                        // Table name
                limit: -1,                              // Maximum number of rows that we want to get
                reverse: false,                         // Optional: Get reversed data
                show_payer: false,                       // Optional: Show ram payer
                lower_bound:0
            };

            if (next_key !== null) {
                req.lower_bound = next_key;
            }

            try {
                result = await wax.rpc.get_table_rows(req);
            }
            catch (e) {
                alert('error getAssetsSA ' + e.message);
                return assetLists;
            }

            for (let n = 0; n < result.rows.length; n++) {


                //console.log('SA ',result.rows[n].author,this.appInfos.SA.collectionName,result.rows[n].category,result.rows[n].id);

                if (result.rows[n].author !== collectionName)
                    continue;

                if (categories.indexOf(result.rows[n].category) < 0)
                    continue;

                let aid = parseInt(result.rows[n].id);
                if (ids.indexOf(aid) >= 0)
                    continue;

                const idata = JSON.parse(result.rows[n].idata);
                const mdata = result.rows[n].mdata;

                //console.log(idata);

                var asset;
                var sus = null;
                var motor = null;
                var weapon = null;
                var radar = null;
                var battery = null;

                if (result.rows[n].category == 'cars') {

                    var jmdata;
                    try {
                        jmdata = JSON.parse(mdata);

                        if (jmdata.suspension)
                            sus = { name: jmdata.suspension.name, tire: jmdata.suspension.tire, force: parseFloat(jmdata.suspension.force), class: jmdata.suspension.class,  compression: parseFloat(jmdata.suspension.compression), stiffness: parseFloat(jmdata.suspension.stiffness), damping: parseFloat(jmdata.suspension.relaxation ? jmdata.suspension.relaxation : jmdata.suspension.damping), friction: parseFloat(jmdata.suspension.friction), width: parseFloat(jmdata.suspension.width), radius: parseFloat(jmdata.suspension.radius) };

                        if (jmdata.motor)
                            motor = { name: jmdata.motor.name, motor: jmdata.motor.motor, class: jmdata.motor.class, maxEngineForce: parseFloat(jmdata.motor.maxEngineForce), maxBreakingForce: parseFloat(jmdata.motor.maxBreakingForce) , nitro : idata.nitro , a : idata.a, b : idata.b, c : idata.c};

                        if (jmdata.weapon)
                            weapon = {  name: jmdata.weapon.name, model: jmdata.weapon.model, class: jmdata.weapon.class, 
                                        projSpeed: parseFloat(jmdata.weapon.speed), projMass: parseFloat(jmdata.weapon.mass) , projDelay : parseFloat(jmdata.weapon.rate) , projSize : parseFloat(jmdata.weapon.size), power : parseFloat(jmdata.weapon.power),durability : parseFloat(jmdata.weapon.durability) 
                                     };

                        if (jmdata.radar)
                            radar = {  name: jmdata.radar.name, model: jmdata.radar.model, class: jmdata.radar.class, 
                                       angle: parseFloat(jmdata.radar.angle), range: parseFloat(jmdata.radar.range) , power : parseFloat(jmdata.radar.power)
                                     };
                       

                        if (jmdata.battery)
                            battery = {   name: jmdata.battery.name, model: jmdata.battery.model, class: jmdata.battery.class, 
                                          charge: parseFloat(jmdata.battery.charge), power : parseFloat(jmdata.battery.power)
                                      }; 
                           
                    }
                    catch (e) {
                        console.log('unable to parse mdata '+e.message+' '+mdata);
                        jmdata = { suspension: null, motor: null, weapon: null, battery: null, radar: null };
                    }
                    asset = { id: result.rows[n].id.toString(), DMG : null, type: 0, claim: false, name: idata.name, chassis: idata.chassis, class: idata.class, massVehicle: parseFloat(idata.massVehicle), steeringClamp: parseFloat(idata.steeringClamp), steeringIncrement: parseFloat(idata.steeringIncrement), maxdmg: parseInt(idata.maxdmg), suspensionRestLength: parseInt(idata.suspensionLength), suspension: sus, motor: motor,  weapon: weapon, radar: radar, battery: battery, mdata: mdata };
                    assetLists.cars.push(asset);
                }
                else if (result.rows[n].category == 'tires'){
                    asset = { id: result.rows[n].id.toString(), type: 0, claim: false, name: idata.name, tire: idata.tire, class: idata.class, force: parseFloat(idata.force), compression: parseFloat(idata.compression), stiffness: parseFloat(idata.stiffness), damping: parseFloat(idata.relaxation ? idata.relaxation : idata.damping), friction: parseFloat(idata.friction), width: parseFloat(idata.width), radius: parseFloat(idata.radius), mdata: mdata };
                    assetLists.tires.push(asset);
                }
                else if (result.rows[n].category == 'motors'){
                    asset = { id: result.rows[n].id.toString(), type: 0, claim: false, name: idata.name, motor: idata.motor, class: idata.class, maxEngineForce: parseFloat(idata.power ? idata.power: idata.maxEngineForce), maxBreakingForce: parseFloat(idata.braking ? idata.braking : idata.maxBreakingForce), nitro : idata.nitro , a : idata.a, b : idata.b, c : idata.c, mdata: mdata };
                    assetLists.motors.push(asset);
                }else if (result.rows[n].category == 'batteries'){
                    asset = { id: result.rows[n].id.toString(), type: 0, claim: false, name: idata.name, model: idata.model, class: idata.class, model: idata.model, charge: parseFloat(idata.charge), power : parseFloat(idata.power), mdata: mdata };
                    assetLists.batteries.push(asset);
                }else if (result.rows[n].category == 'radars'){
                    asset = { id: result.rows[n].id.toString(), type: 0, claim: false, name: idata.name, model: idata.model, class: idata.class, angle: parseFloat(idata.angle), range: parseFloat(idata.range) , power : parseFloat(idata.power), mdata: mdata };
                    assetLists.radars.push(asset);
                }else if (result.rows[n].category == 'weapons'){
                    asset = { id: result.rows[n].id.toString(), type: 0, claim: false, name: idata.name, model: idata.model, class: idata.class, projSpeed: parseFloat(idata.speed), projMass: parseFloat(idata.mass) , projDelay : parseFloat(idata.rate) , projSize : parseFloat(idata.size), power : parseFloat(idata.power), durability : parseFloat(idata.durability), dmg : parseFloat(idata.dmg) , mdata: mdata };
                    assetLists.weapons.push(asset);
                }

                ids.push(aid);
            }

            if (result.more === true)
                next_key = parseInt(result.next_key);
            else
                next_key = null;

        } while (result.more)

        return assetLists;
    }

    async function getTemplate(id, contract, collectionName) {

        if (typeof TemplateData[id] !== 'undefined') {
            return TemplateData[id];
        }

        var req = {
            json: true,                               // Get the response as json
            code: contract,     // Contract that we target
            scope: collectionName, // Account that owns the data
            table: 'templates',                       // Table name
            limit: 1,                                 // Maximum number of rows that we want to get
            lower_bound: id,
            reverse: false,                           // Optional: Get reversed data
            show_payer: false                         // Optional: Show ram payer
        };

        try {
            const result = await wax.rpc.get_table_rows(req);
            const templ = await explore.getTemplate(collectionName, id);

            const ss = await templ._schema;
            const form = await ss.format();

            if (typeof result.rows[0].immutable_serialized_data == 'string')
                TemplateData[id] = await deserialize(hexToBytes(result.rows[0].immutable_serialized_data), form);
            else
                TemplateData[id] = await deserialize(result.rows[0].immutable_serialized_data, form);

            return TemplateData[id];
        }
        catch (e) {
            console.log('getTemplate errror ' + e.message);
            return false;
        }

    }

    async function getSchema(asset, contract, collectionName) {
        const Schema = await explore.getSchema(collectionName, asset.schema_name);
        const form = await Schema.format();

        var data;

        const tid = parseInt(asset.template_id);

        if (tid > 0) {
            data = getTemplate(tid, contract, collectionName);
        }
        else {
            if (typeof asset.immutable_serialized_data == 'string')
                data = await deserialize(hexToBytes(asset.immutable_serialized_data), form);
            else
                data = await deserialize(asset.immutable_serialized_data, form);
        }


        return data;
    }

    async function getMSchema(asset, contract, collectionName) {
        const Schema = await explore.getSchema(collectionName, asset.schema_name);
        const form = await Schema.format();

        var data;
        var s, m, b, r, w;

        if (typeof asset.mutable_serialized_data == 'string')
            data = await deserialize(hexToBytes(asset.mutable_serialized_data), form);
        else
            data = await deserialize(asset.mutable_serialized_data, form);

        if (data.suspension) {

            const str = base58_to_binary(data.suspension);
            const SchemaT = await explore.getSchema(collectionName, "tires");
            const formT = await SchemaT.format();

            s = await deserialize(str, formT);
        }

        if (data.motor) {
            const str = base58_to_binary(data.motor);
            const SchemaM = await explore.getSchema(collectionName, "motors");
            const formM = await SchemaM.format();

            m = await deserialize(str, formM);
        }

        if (data.battery) {
            const str = base58_to_binary(data.battery);
            const SchemaB = await explore.getSchema(collectionName, "batteries");
            const formB = await SchemaB.format();

            b = await deserialize(str, formB);
        }

        if (data.radar) {
            const str = base58_to_binary(data.radar);
            const SchemaR = await explore.getSchema(collectionName, "radars");
            const formR = await SchemaR.format();

            r = await deserialize(str, formR);
        }
        if (data.weapon) {
            const str = base58_to_binary(data.weapon);
            const SchemaW = await explore.getSchema(collectionName, "weapons");
            const formW = await SchemaW.format();

            w = await deserialize(str, formW);
        }


        return { motor: m, suspension: s, battery: b, radar: r, weapon: w, img: data.img };
    }

    /*
    async getTemplate(id)
    {
      if(typeof this.TemplateData[id] !== 'undefined')
      {
          return this.TemplateData[id];
      }
      let data = await jQuery.getJSON({dataType: "json", url :'/getTemplate?template_id='+id});

      if(data.error)
      {
          newAlert('unable to get template data '+ id +' ' +data.error);
          console.log('unable to get template data '+ id +' ' +data.error);
          return;
      }

      this.TemplateData[id] = data.result;
      return this.TemplateData[id];
    }
    */
   export async function getTemplateMintIDAA(blockchaininfos){

      const ids = [];
      const assetLists = blockchaininfos.assetLists;

      for (let k in assetLists) {
            for (let nn = 0; nn < assetLists[k].length; nn++) {
                ids.push(assetLists[k][nn].id);
            }
        }

        const jids = ids.join(',');

        const domain = blockchaininfos.testnet ? 'https://wax.api.atomicassets.io' : 'https://wax.api.atomicassets.io';

        try{
            const r = await fetch(domain + '/atomicassets/v1/assets?collection_name=' + blockchaininfos.AA.collectionName + '&ids=' + jids);
            const mr = await r.json();

            for (let n = 0; n < mr.data.length; n++) {
                for (let k in assetLists) {
                    for (let nn = 0; nn < assetLists[k].length; nn++) {
                        if (assetLists[k][nn].id == mr.data[n].asset_id) {
                            if (mr.data[n].template)
                                assetLists[k][nn].template_mint = mr.data[n].template_mint.toString();

                            //this.assetLists[k][nn].issued_supply = mr.data[n].template.issued_supply;
                        }
                    }
                }
            }
        }
        catch(e){
            
        }
   }

    export async function getAssetsAA(assetLists, myAccount, categories, contractAA, collectionName) {
        let next_key = null;
        let result;



        do {

            var req = {
                json: true,                             // Get the response as json
                code: contractAA,       // Contract that we target
                scope: myAccount,                  // Account that owns the data
                table: 'assets',                        // Table name
                limit: -1,                              // Maximum number of rows that we want to get
                reverse: false,                         // Optional: Get reversed data
                show_payer: false,                       // Optional: Show ram payer
                lower_bound : 0
            };

            if (next_key !== null) {
                req.lower_bound = next_key;
            }

            try {
                result = await wax.rpc.get_table_rows(req);
            }
            catch (e) {
                alert('error getAssetsAA ' + e.message);
                return assetLists;
            }

            for (let n = 0; n < result.rows.length; n++) {
                if (result.rows[n].collection_name !== collectionName)
                    continue;

                if (categories.indexOf(result.rows[n].schema_name) < 0)
                    continue;

             
                const idata = await getSchema(result.rows[n], contractAA, collectionName);//result.rows[n].immutable_serialized_data;

                var asset;

                if (result.rows[n].schema_name == 'cars') {
                    var jmdata;
                    try {

                        jmdata = await getMSchema(result.rows[n], contractAA, collectionName);
                    }
                    catch (e) {
                        jmdata = { suspension: null, motor: null };
                        console.log('getAssetsAA getMSchema error ' + e.message);
                    }

                    let suspension;
                    let motor;
                    let battery;
                    let radar;
                    let weapon;
                    

                    if(idata.suspension){
                        const str = base58_to_binary(idata.suspension);
                        const SchemaT = await explore.getSchema(collectionName, "tires");
                        const formT = await SchemaT.format();

                        //formT.attributes.splice(2,1);
                        suspension = await deserialize(str, formT);
                    }else{
                        suspension = jmdata.suspension;
                    }
        
                    if(idata.motor){
                        const str = base58_to_binary(idata.motor);
                        const SchemaT = await explore.getSchema(collectionName, "motors");
                        const formT = await SchemaT.format();
                        motor = await deserialize(str, formT);
                    }else{
                        motor = jmdata.motor;
                    }

                    if(idata.battery){
                        const str = base58_to_binary(idata.battery);
                        const SchemaT = await explore.getSchema(collectionName, "battery");
                        const formT = await SchemaT.format();
                        battery = await deserialize(str, formT);
                    }else{
                        battery = jmdata.battery;
                    }

                    if(idata.radar){
                        const str = base58_to_binary(idata.radar);
                        const SchemaT = await explore.getSchema(collectionName, "radars");
                        const formT = await SchemaT.format();
                        radar = await deserialize(str, formT);
                    }else{
                        radar = jmdata.radar;
                    }

                    if(idata.weapon){
                        const str = base58_to_binary(idata.weapon);
                        const SchemaT = await explore.getSchema(collectionName, "weapons");
                        const formT = await SchemaT.format();
                        weapon = await deserialize(str, formT);
                    }else{
                        weapon = jmdata.weapon;
                    }

                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?',  type: 1, claim: false , isfree:false, isDemo:false,name: idata.name, chassis: idata.chassis, massVehicle: idata.massVehicle, steeringClamp: idata.steeringClamp, steeringIncrement: idata.steeringIncrement, maxdmg: idata.maxdmg, suspensionRestLength: parseInt(idata.suspensionLength), suspension: suspension, motor: motor, battery: battery, radar: radar, weapon: weapon, DMG: null };
                    assetLists.cars.push(asset);
                }
                else if (result.rows[n].schema_name == 'tires'){
                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?', type: 1, claim: false , isfree:false, isDemo:false,name: idata.name, tire: idata.tire, force: idata.force, compression: idata.compression, stiffness: idata.stiffness, damping: idata.relaxation, friction: idata.friction, width: parseFloat(idata.width), radius: parseFloat(idata.radius), DMG: null };
                    assetLists.tires.push(asset);
                }
                else if (result.rows[n].schema_name == 'motors'){
                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?', type: 1, claim: false , isfree:false, isDemo:false,name: idata.name, motor: idata.motor, maxEngineForce: idata.maxEngineForce, maxBreakingForce: idata.maxBreakingForce, nitro : idata.nitro , a : idata.a, b : idata.b, c : idata.c, DMG: null };
                    assetLists.motors.push(asset);
                }else if (result.rows[n].schema_name == 'batteries'){
                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?', type: 1, claim: false , isfree:false, isDemo:false, name: idata.name, model: idata.model, class: idata.class, model: idata.model, charge: parseFloat(idata.charge), power : parseFloat(idata.power)};
                    assetLists.batteries.push(asset);
                }else if (result.rows[n].schema_name == 'radars'){
                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?', type: 1, claim: false, isfree:false, isDemo:false, name: idata.name, model: idata.model, class: idata.class, angle: parseFloat(idata.angle), range: parseFloat(idata.range) , power : parseFloat(idata.power)};
                    assetLists.radars.push(asset);
                }else if (result.rows[n].schema_name == 'weapons'){
                    asset = { id: result.rows[n].asset_id.toString(), template_mint: '?', type: 1, claim: false, isfree:false, isDemo:false, name: idata.name, model: idata.model, class: idata.class, projSpeed: parseFloat(idata.projSpeed), projMass: parseFloat(idata.projMass) , projDelay : parseFloat(idata.projDelay) , projSize : parseFloat(idata.projSize), power : parseFloat(idata.power), durability : parseFloat(idata.durability), dmg : parseFloat(idata.dmg), blastForce : parseFloat(idata.blastForce), blastRadius : parseFloat(idata.blastRadius)  };
                    assetLists.weapons.push(asset);
                }
            }

            if (result.more === true)
                next_key = parseInt(result.next_key);
            else
                next_key = null;

        } while (result.more)

      
        return assetLists;
    }

    async function doTx(logType, TxData, TxOptions){

        let result;
        switch (logType) {
            case 0:
                try {
                    if (!isAutoLoginAvailable) {
                        await wax.login();
                    }
                    result = await wax.api.transact(TxData, TxOptions);
                }
                catch (e) {
                    console.log("transaction error " + e.message);
                    alert("transaction error " + e.message);
                    return false;
                }
            break;
            case 1:
                try {
                    result = await link.transact(TxData, TxOptions);
                }
                catch (e) {
                    console.log("transaction error " + e.message);
                    alert("transaction error " + e.message);
                    return false;
                }
            break;
        }
          return true;
    }



    export async function initdmgWax(myAccount, logType, carid, type, mainContract) {

        console.log('initdmgWax '+myAccount)

        const TxData = { actions: [
            { account: mainContract, 
              name: "initdmg", 
              authorization: [{ actor: myAccount, permission: "active" }], 
              data: { owner: myAccount, id: parseInt(carid), type: type } }] };
              
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(logType, TxData, TxOptions);
    }

    export async function unmountAccessSA(blockchaininfos, carid, cat, name) {
        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "unmount", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { owner: blockchaininfos.myAccount, carid: carid, category: cat, assetname: name } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
    }
    export async function unmountAccessAA(blockchaininfos,carid, cat, name) {
        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "unmountaa", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { owner: blockchaininfos.myAccount, carid: carid, category: cat, assetname: name } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
    }

 export async function mountAccessSA(blockchaininfos, carid, aid) {
        const TxData = { actions: [{ account:blockchaininfos.SA.contract, name: "transfer", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { from: blockchaininfos.myAccount, to: blockchaininfos.mainContract, assetids: [aid], memo: 'm:' + carid } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
    }
    export async function mountAccessAA(blockchaininfos, carid, aid) {
        const TxData = { actions: [{ account: blockchaininfos.AA.contract, name: "transfer", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { from: blockchaininfos.myAccount, to: blockchaininfos.mainContract, asset_ids: [aid], memo: 'm:' + carid } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
    }
    export async function doClaim(blockchaininfos, ids) {
        const TxData = { actions: [{ account: blockchaininfos.SA.contract, name: "claim", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { claimer: blockchaininfos.myAccount, assetids: ids } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType, TxData, TxOptions);
    }
    export async function getRecipesSA(SA, mainContract, bluePrints){

        let myRecipes = [];


        var dreq = {
            json: true,                             // Get the response as json
            code: mainContract,       // Contract that we target
            scope: mainContract,      // Account that owns the data
            table: 'recipe',                    // Table name
            limit: -1,                              // Maximum number of rows that we want to get
            reverse: false,                         // Optional: Get reversed data
            show_payer: false                       // Optional: Show ram payer
        };

        let recipes;
        
        try{
            recipes = await wax.rpc.get_table_rows(dreq);
        }catch(e){
            alert('getRecipes : could not read recipe tabe !');
            return myRecipes;
        }

        let oidSA = [];
        
        for (let n = 0; n < recipes.rows.length; n++) {

            const bpMask = 1 << recipes.rows[n].blueprint;

            if((recipes.rows[n].type === 0)&&((bluePrints & bpMask)!==0)){
                const id = parseInt(recipes.rows[n].assetid);
                myRecipes[id] ={rid : recipes.rows[n].id, steel : parseFloat(recipes.rows[n].steel), tech : (parseInt(recipes.rows[n].tech) / 100.0).toFixed(2) };
            }
        }

        var areq = {
            json: true,                              // Get the response as json
            code: SA.contract,         // Contract that we target
            scope: SA.collectionName,  // Account that owns the data
            table: 'sassets',                        // Table name
            limit: -1,                               // Maximum number of rows that we want to get
            reverse: false,                          // Optional: Get reversed data
            show_payer: false                        // Optional: Show ram payer
        };
        let aresult;
        try {
            aresult = await wax.rpc.get_table_rows(areq);
        }
        catch (e) {
            alert('error getRecipessSA ' + e.message);
            return myRecipes;
        }

        for (let n = 0; n < aresult.rows.length; n++) {

            const id = parseInt(aresult.rows[n].id);

            if (!myRecipes[id])
                continue;
            
            const data = JSON.parse(aresult.rows[n].idata);
            myRecipes[id].name = data.name;
            myRecipes[id].img = data.img;

        }

        return myRecipes;
    }

    export async function buyNitroWax(blockchaininfos, n,  gameConfig) {
        const memo = 'b:0';
        const quantity = parseFloat(n * gameConfig.nitro_price).toFixed(4) + ' STEEL';

        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "transfer", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { from: blockchaininfos.myAccount, to: blockchaininfos.mainContract, quantity: quantity, memo: memo } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        await doTx(blockchaininfos.logType, TxData, TxOptions);
    }
    export async function eraseNitroWax(blockchaininfos) {
        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "freenitros", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { owner: blockchaininfos.myAccount } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        await doTx(blockchaininfos.logType, TxData, TxOptions);
    }

    export async function initUserDataWax(blockchaininfos){

        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "initinfos", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], data: { owner: blockchaininfos.myAccount} }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(blockchaininfos.logType,TxData, TxOptions)
        
    }


    
    export async function checkquestWax(blockchaininfos, assetid = "", assettype = 0) {
        const TxData = { actions: [{ account: blockchaininfos.mainContract, name: "checkquest", authorization: [{ actor: this.myAccount, permission: "active" }], data: { owner: blockchaininfos.account, assetid : assetid, assettype : assettype } }] };
        const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
        return await doTx(TxData, TxOptions);
    }

        export async function modStatWax(blockchaininfos, gameConfig, carid, cartype, statMod) {

            const TxData = { actions: []};

            for(let key in statMod){

                if(statMod[key]==0)
                    continue;

                let k= '';
                switch (key) {
                    case "compression": k = 'c'; break;
                    case "damping": k = 'd'; break;
                    case "friction": k = 'f'; break;
                    case "stiffness": k = 's'; break;
                    case "force": k = 'p'; break;
                }
    
                const cmd = statMod[key] > 0 ? 'u:' : 'd:';
                const memo = cmd + k + ':' + cartype + ':' + carid;
                const q = Math.abs(gameConfig.steel_per_up * Math.abs(statMod[key]));
        
                TxData.actions.push({   account: blockchaininfos.mainContract, name: "transfer", authorization: [{ actor: blockchaininfos.myAccount, permission: "active" }], 
                                        data: { from: blockchaininfos.myAccount, to: blockchaininfos.mainContract, quantity: q.toFixed(4) + ' STEEL', memo: memo } });
            }

            const TxOptions = { blocksBehind: 3, expireSeconds: 30, sign: true };
            await doTx(blockchaininfos.logType, TxData, TxOptions);

        }

    